import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '@/store/slices/market.slice'; // Import your action creators
import * as api from '@/services/market'; // Import your API functions
import { PayloadAction } from '@reduxjs/toolkit';
import { isBoolean } from 'lodash';
import { IApiResponse, IFetchMarket } from '@/services/market/market.type';
import { GET_MARKET_ACTION_TYPE } from '@/constant/market/market.constant';
import { isSameRequestParams } from '@/utils/requestParamsChecker';

// Define action types
export interface GetMarketsAction extends PayloadAction<number> {
  type: 'market/getMarkets';
}
export interface GetMarketsListAction extends PayloadAction<number> {
  type: 'market/getMarketsList';
}

function* getMarkets(action: GetMarketsAction): Generator {
  try {
    const response: any = yield call(api.fetchMarkets as any, action?.payload);
    if (isValidMarketsResponse(response?.data)) {
      yield put(actions.getMarketsSuccess(response?.data));
    } else {
      yield put(actions.getMarketsFailure(response?.data));
    }
  } catch (error: any) {
    yield put(actions.getMarketsFailure(error));
  }
}

function* getAllMarketsList(action: PayloadAction<IFetchMarket>): Generator {
  try {
    if (isSameRequestParams(action.payload)) {
      return;
    }
    const response: any = yield call(api.fetchAllMarketsList as any, action?.payload);
    if (isValidMarketsResponse(response?.data) || response?.data?.success) {
      yield put(
        actions.getMarketsListSuccess({
          ...response?.data,
          operatorId: action?.payload?.operatorId,
        }),
      );
    } else {
      yield put(actions.getMarketsListFailure(response?.data));
    }
  } catch (error: any) {
    yield put(actions.getMarketsListFailure(error?.response?.data));
  }
}

function isValidMarketsResponse(response: IApiResponse): boolean {
  return (
    isBoolean(response.success) ||
    response.message === 'Succesfully grabbed markets.'
  );
}

function* marketSaga(): Generator {
  // Watch for the specific action type
  yield takeLatest<GetMarketsAction>(GET_MARKET_ACTION_TYPE, getMarkets);
  yield takeLatest(actions.getMarketsList.type, getAllMarketsList);
}

export default marketSaga;
